import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaRegLightbulb, FaChartLine, FaClock } from 'react-icons/fa';
import { useAuth } from './AuthContext';
import './SolarQuotePro.css';

const SolarQuotePro = () => {
  const { profile, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="solar-quote-pro">

      {/* Barre utilisateur */}
      <div style={{
        position: 'absolute', top: 0, right: 0,
        display: 'flex', alignItems: 'center', gap: '12px',
        padding: '12px 20px', zIndex: 10
      }}>
        <span style={{ color: 'white', fontSize: '14px', opacity: 0.9 }}>
          👤 {profile?.nom || 'Utilisateur'}
          {profile?.role === 'manager' && (
            <span style={{
              marginLeft: '6px', fontSize: '11px',
              background: 'rgba(255,255,255,0.2)',
              padding: '2px 8px', borderRadius: '999px'
            }}>Manager</span>
          )}
        </span>
        <button
          onClick={handleSignOut}
          style={{
            background: 'rgba(255,255,255,0.15)',
            border: '1px solid rgba(255,255,255,0.3)',
            color: 'white', borderRadius: '6px',
            padding: '6px 14px', fontSize: '13px',
            cursor: 'pointer'
          }}
        >
          Déconnexion
        </button>
      </div>

      <header className="hero">
        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          SolarQuotePro<sup>TM</sup>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Transformez vos devis solaires en expériences !
        </motion.p>
      </header>

      <section className="features">
        <motion.div className="feature-card" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <FaRegLightbulb className="feature-icon" />
          <h2>Gagnez des clients en un clin d'œil</h2>
          <p>Des devis sur mesure générés en quelques clics pour séduire rapidement et efficacement vos clients</p>
        </motion.div>
        <motion.div className="feature-card" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <FaChartLine className="feature-icon" />
          <h2>Des devis qui convertissent</h2>
          <p>Des visuels percutants et des images produits intégrées pour un visuel fort et des décisions rapides</p>
        </motion.div>
        <motion.div className="feature-card" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <FaClock className="feature-icon" />
          <h2>Optimisez votre temps</h2>
          <p>Une interface intuitive pour gagner en productivité et simplifier votre quotidien professionnel</p>
        </motion.div>
      </section>

      <motion.div
        className="cta-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
        style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}
      >
        <Link to="/client-info" className="cta-button">
          Nouveau devis
        </Link>
        <button
          onClick={() => navigate(profile?.role === 'manager' ? '/manager-dashboard' : '/quote-dashboard')}
          className="cta-button"
          style={{ background: 'rgba(255,255,255,0.15)', border: '2px solid white', cursor: 'pointer' }}
        >
          Tableau de bord
        </button>
      </motion.div>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} SolarQuotePro™ by Takoussane Energy. Version v1.0.1. Tous droits réservés.</p>
      </footer>
    </div>
  );
};

export default SolarQuotePro;
